import { render, staticRenderFns } from "./password_update.vue?vue&type=template&id=45281a1c&scoped=true&"
import script from "./password_update.vue?vue&type=script&lang=js&"
export * from "./password_update.vue?vue&type=script&lang=js&"
import style0 from "./password_update.vue?vue&type=style&index=0&id=45281a1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45281a1c",
  null
  
)

export default component.exports